import { Component, input, output, signal } from "@angular/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { TranslatePipe } from "@ngx-translate/core";

import { AppLoaderComponent } from "@shared/components/app-loader";
import { IAction } from "@shared/interfaces";

@Component({
    selector: "wk-modal",
    templateUrl: "./modal.component.html",
    styleUrl: "./modal.component.scss",
    host: {
        class: "wk-modal",
        "[attr.title]": "null",
    },
    imports: [JumpstartComponentsModule, TranslatePipe, AppLoaderComponent],
})
export class ModalComponent {
    title = input.required<string>();
    description = input<string>();
    confirmAction = input.required<IAction>();
    confirmDisabled = input(false);

    public closeModal = output<void>();

    protected isUpdating = signal<boolean>(false);

    protected submit() {
        if (!this.isUpdating() && !this.confirmDisabled()) {
            this.isUpdating.set(true);
            this.confirmAction().event();
        }
    }

    protected close() {
        if (!this.isUpdating()) {
            this.closeModal.emit();
        }
    }

    protected handleUserRequest() {
        this.close();
    }
}
